import { isEmpty } from '../../../utils'
import { isPlainObject, isNil } from 'lodash-es'

export const singleChoiceSchemaHandle = {
  handle (node, {pageType}) {
    const {choiceValues, props, selectedShowStyle} = node
    props.options = choiceValues.map(item => {
      return {
        choiceKey: item.choiceValue.choiceKey,
        value: item.choiceValue.value,
        state: item.state,
        defaultChoice: item.defaultChoice
      }
    })
    if (pageType === 'list') {
      props.uiComponent = 1
    }
    props.selectedShowStyle = selectedShowStyle
  }
}

export const singleChoiceProps = {
  showTooltip: {
    type: Boolean,
    default: true
  },
  value: {
    type: String,
    default: ''
  },
  // 单选样式
  uiComponent: {
    type: Number,
    default: 1
  },
  // 默认未选展示名称
  placeholder: {
    type: String,
    default: '请选择'
  },
  // 最大选择项的数量,
  selectMaxLength: {
    type: Number,
    default: 2000
  },
  // 是否进搜索
  searchable: {
    type: Boolean,
    default: false
  },
  // 数据源
  options: {
    type: Array,
    default: () => []
  },
  // 只读
  disabled: {
    type: Boolean,
    default: false
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  },
  name: {
    type: String,
    default: ''
  },
  // 组件大小
  size: {
    type: String,
    default: 'small'
  },
  // 选项排列方式 2为竖排
  selectedShowStyle: Number
}

export function initValue (val, {options}) {
  if (isNil(val)) {
    return '-'
  }
  const _val = isPlainObject(val)
    ? (val.value 
      ? val.value 
      : (options.find(
        v => v.choiceKey === String(val.key)
      ) || {}).value
    )
    : (options.find(
      v => v.choiceKey === String(val)
    ) || {}).value
  return isEmpty(_val) ? '-' : _val
}